import { __assign } from '../../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import { CustomErrorSection } from './CustomErrorSection.esm.js';
import Figure404 from './Figures/Figure404.esm.js';

var DEFAULT_VALUES = {
    ctaText: 'Go back',
    description: 'You can try:',
    figure: React.createElement(Figure404, null),
    headingText: 'Oops!',
    pageTitle: 'Page not found',
    textList: ['Checking the URL', 'Using site search to find something specific', 'Going back to the previous page'],
    title: '404. Page not found.',
};
var NotFoundPage = function (props) {
    var componentProps = __assign(__assign({}, DEFAULT_VALUES), props);
    return React.createElement(CustomErrorSection, __assign({}, componentProps));
};

export { DEFAULT_VALUES, NotFoundPage };
//# sourceMappingURL=NotFoundPage.esm.js.map
